import * as axiosBase from '@/api/index.js';

// 创建群组
export let groupAdd = function(params) {
  return axiosBase.POST("/medicalapp/group/add", params)
}
// 修改群组信息
export let groupUpdate = function(params) {
  return axiosBase.POST("/medicalapp/group/update", params)
}
// 查询我创建的或加入的群组
export let query = function(params) {
  return axiosBase.GET("/medicalapp/group/query", params)
}
// 查询群组成员
export let queryMember = function(params) {
  return axiosBase.GET("/medicalapp/group/queryMember", params)
}
// 查询群基本信息
export let queryInfo = function(params) {
  return axiosBase.GET("/medicalapp/group/queryInfo", params)
}
// //保存群的昵称
// export let saveNickname = function(params) {
//   return axiosBase.POST("/medicalapp/member/saveNickname", params)
// }
// 头像上传
export let saveAvata = function(params) {
  return axiosBase.POST("/medicalapp/general/upload", params)
}
// //保存头像
// export let saveAvatar = function(params) {
//   return axiosBase.POST("/medicalapp/member/saveAvatar", params)
// }
// //保存数据分享权限设置
// export let savePrivacy = function(params) {
//   return axiosBase.POST("/medicalapp/healthSettings/savePrivacy", params)
// }
// 保存异常项数据设置
export let saveAbnormal = function(params) {
  return axiosBase.POST("/medicalapp/healthSettings/saveAbnormal", params)
}
// 查询异常值的设置范围值
export let queryAbnormal = function(params) {
  return axiosBase.GET("/medicalapp/healthSettings/queryAbnormal", params)
}
// 查询群成员健康数据
export let queryHealth = function(params) {
  return axiosBase.GET("/medicalapp/member/queryHealth", params)
}
// 查询有数据的日期
export let queryDate = function(params) {
  return axiosBase.GET("/medicalapp/member/queryDate", params)
}
// 新增成员
export let memberAdd = function(params) {
  return axiosBase.POST("/medicalapp/member/add", params)
}
// 解散群
export let remote = function(params) {
  return axiosBase.POST("/medicalapp/group/del", params)
}
// 查询当前用户昵称和头像
export let userQuery = function(params) {
  return axiosBase.GET("/usercenter/userInfo/query", params)
}
// 修改成员昵称
export let updateNickname = function(params) {
  return axiosBase.POST("/medicalapp/member/updateNickname", params)
}
// 删除成员
export let memberDel = function(params) {
  return axiosBase.POST("/medicalapp/member/del", params)
}
//更新成员
// export let memberUpdate = function(params) {
//   return axiosBase.POST("/medicalapp/member/update", params)
// }
// //查询数据分享权限
// export let queryPrivacy = function(params) {
//   return axiosBase.GET("/medicalapp/healthSettings/queryPrivacy", params)
// }

// 查询用户加群状态
export let state = function(params) {
  return axiosBase.GET("/medicalapp/member/state", params)
}

// 账号邀请
export let invite = function(params) {
  return axiosBase.POST("/medicalapp/member/invite", params)
}

// 查询消息列表（未处理）
export let queryMessage = function(params) {
  return axiosBase.GET("/medicalapp/member/queryMessage", params)
}

// 再次邀请
export let inviteAgain = function(params) {
  return axiosBase.POST("/medicalapp/member/inviteAgain", params)
}

// 拒绝邀请
export let inviteRefuse = function(params) {
  return axiosBase.POST("/medicalapp/member/inviteRefuse", params)
}



// WEBPACK FOOTER //
// ./src/api/member/member.js